import mycv from '../assets/pdf/mycv.pdf'
import pixxx from '../assets/jpg/pixxxx.jpg'

export const headerData = {
    name: 'Web Developer',
    title: "Akshitha Chinthakindi",
    desciption:"I am an undergraduate pursuing my Bachelors in Computer Science & Technology. I am an enthusiastic learner with creative insights and I never shy away from trying out new things and implementing them. I enjoy solving puzzles and taking part in coding competitions. My interests are web development and I enjoy working with design and Illustrations as well. ",
    // image: 'https://raw.githubusercontent.com/PhantomScript/asset-container/main/developer-portfolio/landingImg.png',
    image: pixxx,
    resumePdf: mycv
}
